import {useAuth0} from "@auth0/auth0-react";

interface IfAuthenticatedProps {
    children: any;
}

function IfAuthenticated({children}: IfAuthenticatedProps) {
    const {isAuthenticated} = useAuth0();

    return isAuthenticated ? children : null;
}

export default IfAuthenticated;